import { createApp } from 'vue'
import { createPinia } from 'pinia'
import AppLayout from '@/layouts/AppLayoutApp.vue'
import App from './App.vue'
import router from './router'

import './assets/main.css'
import './assets/style.css'
import './assets/tailwind.css';

// Dynamically set favicon based on subdomain
const hostname = window.location.hostname;
const subdomain = hostname.split('.')[0];

const setFavicon = (subdomain: string) => {
  const faviconPath = subdomain === 'underscore-talent' 
    ? '/favicon/underscore-favicon.png' 
    : '/favicon/shorthand-favicon.png';
  
  // Update existing favicon link or create new one
  let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = faviconPath;
};

const setDocumentTitle = (subdomain: string) => {
  document.title = subdomain === 'underscore-talent' 
    ? 'Underscore Talent' 
    : 'Shorthand Studios';
};

setFavicon(subdomain);
setDocumentTitle(subdomain);

const app = createApp(App)

app.use(createPinia())
app.use(router)

app.config.errorHandler = function (err: any, vm, info) {
    // Handle the error globally
    console.error("Global error:", err);
    console.log("Vue instance:", vm);
    console.log("Error info:", info);

    return null
}

app.directive('scroll-fade', {
  mounted(el) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        entry.isIntersecting ? el.classList.add('opacity-100') : el.classList.remove('opacity-100');
      },
      { threshold: 0.1 }
    );
    observer.observe(el);
  },
});

app.directive('on-render', {
  mounted(el, binding) {
    binding.value();
  }
});

app.component('AppLayout', AppLayout).mount('#app')
